module.exports = __webpack_public_path__ + "static/media/dropdown.0e29f173.svg";